
import * as echarts from 'echarts';

export default {
  name: 'CePie',
  props: {
    id: { type: String, default: () => (`c-e-pie-${Math.random().toString().substring(2)}`) },
    resizeCondition: { type: Array, default: () => ['width'] },
    theme: { type: String, default: () => 'macarons' },
    data: {
      type: Array,
      default: () => [
        { name: '', value: '0', color: '#fe4ecd' },
        { name: '', value: '0', color: '#2697ff' },
        { name: '', value: '0', color: '#4fffff' },
        { name: '', value: '0', color: '#892bfe' },
      ]
    },
    title: { type: String, default: () => '标题' },
    name: { type: String, default: () => '' },
    width: { type: String, default: () => '100%' },
    height: { type: String, default: () => '100%' },
    colors: { type: Array, default: () => ['#fe4ecd', '#2697ff', '#4fffff', '#892bfe'] },
    type: { type: String, default: () => 'pie' },
    radius: { type: Array, default: () => ['35%', '55%'] },
    roseType: { type: String, default: () => '' },
    showLegend: { type: Boolean, default: () => false },
    delay: { type: Number, default: () => 100 },
    backgroundColor: { type: String, default: () => '' },
  },
  data() {
    return {
      charts: null,
      option: {},
    }
  },
  watch: {
    data(prev, next) {
      if (JSON.stringify(prev) != JSON.stringify(next)) this.create();
    }
  },
  mounted() {
    let timeout = null;
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    } else {
      timeout = setTimeout(() => {
        this.create();
        clearTimeout(timeout);
        timeout = null;
      }, this.delay);
    }
  },
  beforeDestroy() {
    this.cancel();
  },
  methods: {
    create() {
      this.cancel();
      const theme = require(`echarts/theme/${this.theme}`);
      this.charts = echarts.init(this.$el, theme && theme != '' ? this.theme : '');
      let series = [
        {
          name: this.name,
          type: this.type,
          radius: this.radius,
          roseType: this.roseType,
          center: ['50%', '40%'], // 位置调整
          data: this.data.length > 0 && this.data.map((a, b) => ({
            selected: false,
            label: {
              formatter: ({ name, value }) => value + '%',
            },
            labelLine: {
              lineStyle: {
                color: 'rgba(255, 255, 255, 0)'
              },
              smooth: 0.2,
              length: 10,
              length2: 10,
            },
            itemStyle: {
              normal: {
                color: a.color ? a.color : this.colors[b],
                shadowBlur: 200,
                shadowColor: 'rgba(0, 0, 0, 0.4)',
                shadowOffsetX: -4,
                shadowOffsetY: 4,
              },
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
              }
            },
            animationDelay: c => c * b * 100,
            ...a,
          })).sort((a, b) => (a.value - b.value)),
          animationType: 'scale',
          animationEasing: 'elasticOut',
          animationDelay: (idx) => Math.random() * 200,
        },
      ];
      this.option = {
        backgroundColor: this.backgroundColor,
        tooltip: {
          trigger: 'item',
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        grid: {
          show: false,
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          containLabel: false,
        },
        legend: {
          orient: 'horizontal',
          x: 'center',
          y: 'bottom',
          itemWidth: 14,
          itemHeight: 14,
          itemStyle: {
            borderType: '',
          },
          borderRadius: 0,
          itemGap: 8,
          textStyle: {
            color: '#fff'
          },
          data: this.data.map(a => a.name),
        },
        calculable: true,
        series,
      };
      this.charts.clear();
      this.charts.setOption(this.option);
      let timeout = null;
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      } else {
        timeout = setTimeout(() => {
          addEventListener('resize', () => this.charts && this.charts.resize());
          addEventListener('transitionend', a => this.charts && this.resize(a));
          clearTimeout(timeout);
          timeout = null;
        }, this.delay);
      }
    },
    resize({ propertyName }) {
      this.resizeCondition.includes(propertyName) && this.charts.resize();
    },
    cancel() {
      if (this.charts) {
        removeEventListener('transitionend', this.charts.resize);
        removeEventListener('resize', this.resize);
        this.$nextTick(() => {
          this.charts.dispose();
          this.charts = null;
        });
      }
    },
  },
  render() {
    return (<div key={this.id} class="c-e-pie" style={{ width: this.width, height: this.height }} />);
  }
}